button{height:32px}.client-selector{height:32px;float:right}.multiclient-select-button{width:60%!important;margin-left:20%!important;margin-right:20%;margin-bottom:5px}.modal-footer{padding:10px 0 10px 10px}.modal-footer button i{margin-right:5px}
/*# sourceMappingURL=client-selector.component-RXP3CSTL.css.map */
